import { Identifier } from 'types/utilityTypes';

export enum NoteTypes {
  Workout = 'Workout',
  Assessment = 'Assessment',
  Visit = 'Visit',
}

export interface Note {
  id: Identifier;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  userId: Identifier | undefined;
  notableId: Identifier | undefined;
  notableType: string | undefined;
  date: Date;
  notes: string | undefined;
  title: string | undefined;
  createdById: Identifier | undefined;
}

export interface NoteFilters {
  startDate?: Date | null;
  endDate?: Date | null;
  types?: NoteTypes[] | null;
}
